"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Custom360 = /*#__PURE__*/function () {
  function Custom360(client) {
    (0, _classCallCheck2["default"])(this, Custom360);
    this.client = client;
    this.custom360Url = '/survey-request';
  }

  (0, _createClass2["default"])(Custom360, [{
    key: "custom360RequestId",
    value: function custom360RequestId(clientId, data) {
      return this.client.get("".concat(this.custom360Url, "/custom-360/").concat(clientId, "/questions"));
    }
  }, {
    key: "custom360Answers",
    value: function custom360Answers(requestId, data) {
      return this.client.post("".concat(this.custom360Url, "/custom-360/").concat(requestId, "/answers"), data);
    }
  }]);
  return Custom360;
}();

exports["default"] = Custom360;